import api from '@/services/api';
import router from '@/router';
import store from '@/state/store';
import i18n from '@/i18n';

const ERROR_CODE_VALIDATE = 422;
const ERROR_CODE_NOT_FOUND = 404;
const ERROR_CODE_UNAUTHORIZED = 401;
const ERROR_CODE_BAD_REQUEST = 400;
const ERROR_CODE_FORBIDDEN = 403;
const ERROR_CODE_SERVER = 500;
const ERROR_CODE_SERVICE_UNAVAILABLE = 503;
const ERROR_CODE_REQUEST_TIMEOUT = 408;

export default {
  async get (url, params = {}) {
    try {
      const result = await api.get(url, params);

      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      return this.handleError(error);
    }
  },
  async getWithLoading (url, params = {}, timeOut = null) {
    try {
      store.dispatch('setIsShowLoading', true);
      if (timeOut != null) {
        api.setTimeout(timeOut * 1000);
      }
      const result = await api.get(url, params);
      store.dispatch('setIsShowLoading', false);

      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      store.dispatch('setIsShowLoading', false);
      return this.handleError(error);
    }
  },
  async post (url, params = {}) {
    try {
      store.dispatch('setIsShowLoading', true);
      const result = await api.post(url, params);
      store.dispatch('setIsShowLoading', false);

      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      store.dispatch('setIsShowLoading', false);
      return this.handleError(error);
    }
  },
  async postWithoutLoading (url, params = {}) {
    try {
      const result = await api.post(url, params);
      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      return this.handleError(error);
    }
  },
  async put (url, params = {}) {
    try {
      store.dispatch('setIsShowLoading', true);
      const result = await api.put(url, params);
      store.dispatch('setIsShowLoading', false);

      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      return this.handleError(error);
    }
  },
  async patch (url, params = {}) {
    try {
      const result = await api.patch(url, params);
      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      return this.handleError(error);
    }
  },
  async delete (url, params = {}) {
    try {
      const result = await api.delete(url, params);
      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      console.log('catch', error);
    }
  },
  async download (url, params = {}) {
    try {
      const result = await api.get(url, params, { responseType: 'blob' });
      const { status, data, headers } = result;

      let filename = '';
      const disposition = headers['content-disposition'];
      if (disposition.indexOf('filename*=') !== -1) {
        filename = decodeURIComponent(disposition.split('filename*=')[1].replace('utf-8\'\'', ''));
      } else {
        filename = disposition.split(';')[1].split('filename=')[1].split('"')[1];
      }

      return {
        status: true,
        code: status,
        data,
        headers,
        filename,
      };
    } catch (error) {
      return this.handleError(error);
    }
  },
  async downloadPost (url, params = {}) {
    try {
      const result = await api.post(url, params, {}, { responseType: 'blob' });
      const { status, data, headers } = result;
      return {
        status: true,
        code: status,
        data,
        headers,
      };
    } catch (error) {
      let errorString = JSON.parse(await error.response.data.text());

      return {
        status: false,
        code: errorString.code,
        data: {
          'message': errorString.message
        },
      }
    }
  },
  async formUpload (url, params = {}) {
    try {
      store.dispatch('setIsShowLoading', true);
      const result = await api.post(url, params, {
        'Content-Type': 'multipart/form-data',
      });
      store.dispatch('setIsShowLoading', false);
      const { status, data } = result;
      return {
        status: true,
        code: status,
        data,
      };
    } catch (error) {
      store.dispatch('setIsShowLoading', false);
      return this.handleError(error);
    }
  },
  handleError (error) {
    const { response, request, message } = error;

    const { status, data } = response || {};
    let errorCode = status || ERROR_CODE_SERVER;
    if (message.indexOf('timeout') !== -1) {
      errorCode = ERROR_CODE_REQUEST_TIMEOUT;
    }
    if (response) {
      this.handleResponseError(response);
    } else if (request) {
      this.handleNoResponse(request);
    } else {
      console.log('Error', error.message);
    }

    return {
      status: false,
      code: errorCode,
      data,
    };
  },
  async handleResponseError (response) {
    const { status, data, config } = response;

    const errorCode = status || ERROR_CODE_SERVER;
    const errorMessage = data ? (data.message || data.error) : i18n.t('common.message.error');

    switch (errorCode) {
      case ERROR_CODE_UNAUTHORIZED:
        console.log('http.js ERROR_CODE_UNAUTHORIZED logout');
        await store.dispatch('auth/logout');
        router.push({ name: 'login' });
        break;
      case ERROR_CODE_BAD_REQUEST:
        return {
          status: false,
          errorCode: errorCode,
          data: data ? data.errors : {},
          message: errorMessage,
        };
      default:
        console.log(response);
        break;
    }
  },
  handleNoResponse (request) {
    console.log('handleNoResponse', request);
  },

  ERROR_CODE_VALIDATE,
  ERROR_CODE_NOT_FOUND,
  ERROR_CODE_UNAUTHORIZED,
  ERROR_CODE_BAD_REQUEST,
  ERROR_CODE_FORBIDDEN,
  ERROR_CODE_SERVER,
  ERROR_CODE_SERVICE_UNAVAILABLE
};
